export default __webpack_public_path__ + "static/box-20b101975952d55aa19929b58e0ed8c0.png";